module.exports = __webpack_public_path__ + "f52a2f7b5a42c9a14ad7f885ff1f3668.svg";